import { render } from "./FinancialDiagnosis.vue?vue&type=template&id=0fa921c6"
import script from "./FinancialDiagnosis.vue?vue&type=script&lang=js"
export * from "./FinancialDiagnosis.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__